import { ReactNode } from "react";
import { cn } from "../../utils/class-names";

export const NoPositions = {
  Root,
  Heading,
  Description,
};

interface RootProps {
  className?: string;
  children?: ReactNode;
}

function Root({ className, children }: RootProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-1 p-6 text-center rounded-lg h-80 sm:h-96 bg-shale-800",
        className
      )}
    >
      {children}
    </div>
  );
}

interface HeadingProps {
  className?: string;
  children?: ReactNode;
}

function Heading({ className, children }: HeadingProps): JSX.Element {
  return (
    <h2 className={cn("text-xl font-bold text-white md:text-2xl", className)}>
      {children}
    </h2>
  );
}

interface DescriptionProps {
  className?: string;
  children?: ReactNode;
}

function Description({ className, children }: DescriptionProps): JSX.Element {
  return (
    <p className={cn("text-base text-shale-200", className)}>{children}</p>
  );
}
